import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private pendingRequests = 0;
  readonly visible = signal(false);

  show(): void {
    this.pendingRequests++;
    this.visible.set(true);
  }

  hide(): void {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    this.visible.set(this.pendingRequests > 0);
  }
}
